import { render, staticRenderFns } from "./AddRow.vue?vue&type=template&id=13ba7ffc&"
import script from "./AddRow.vue?vue&type=script&lang=js&"
export * from "./AddRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports